<template>
  <div class="point-overview">
    <article v-if="errorMessage" class="message is-danger">
      <div class="message-header">
        <p>Error</p>
        <button type="button" class="delete" aria-label="delete" @click="errorMessage = null"></button>
      </div>
      <div class="message-body">
        {{errorMessage}}
      </div>
    </article>
    <div v-else-if="showOverview" class="point-details is-size-5">
      <div class="item level is-mobile">
        <p class="level-left">Battery</p>
        <span class="icon is-large level-right" v-if="showIcons" @click="toggleIcons()">
          <i v-if="pointCell.point.battery.percentage > 80" class="fas fa-2x fa-battery-full"></i>
          <i v-else-if="pointCell.point.battery.percentage > 65" class="fas fa-2x fa-battery-three-quarters"></i>
          <i v-else-if="pointCell.point.battery.percentage > 40" class="fas fa-2x fa-battery-half"></i>
          <i v-else-if="pointCell.point.battery.percentage > 32" class="fas fa-2x fa-battery-quarter"></i>
          <i v-else-if="pointCell.point.battery.percentage <= 32" class="fas fa-2x fa-battery-empty"></i>
        </span>
        <span class="level-right" v-else @click="toggleIcons()">{{pointCell.point.battery.percentage}}% {{pointCell.point.battery.voltage}}mV</span>
      </div>
      <div class="item level is-mobile">
        <p class="level-left">Time passed</p>
        <p class="level-right">{{timePassed}}</p>
      </div>
      <div class="item level is-mobile">
        <p class="level-left">Date</p>
        <p class="level-right">{{createdToLocal(pointCell.point.created)}}</p>
      </div>
      <p v-if="pointCell.point.accesspoints.length > 0">Accesspoints</p>
      <table v-if="pointCell.point.accesspoints.length > 0" class="table is-size-6 is-bordered is-striped is-narrow is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th><abbr title="SSID of accesspoint">Name</abbr></th>
            <th><abbr title="Signal strength of WiFi">Strength</abbr></th>
          </tr>
        </thead>
        <tbody>
          <tr
          v-for="ap in pointCell.point.accesspoints"
          :key="ap.macAddress">
            <th>{{ap.name}}</th>
            <td>{{dBmToPercentage(ap.signalStrength)}}%</td>
          </tr>
        </tbody>
      </table>
      <span v-else>No accesspoints found</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pointOverview',
  data: () => {
    return {
      showIcons: true,
      currentTime: 0,
      showOverview: true,
      errorMessage: null
    }
  },
  props: {
    pointCell: [Object]
  },
  computed: {
    timePassed () {
      if (typeof this.pointCell.point !== 'object') return ''
      const pointTime = new Date(this.pointCell.point.created).getTime()
      const secondsPassed = (this.currentTime / 1000) - (pointTime / 1000)
      if (secondsPassed < 100) return `${Math.floor(secondsPassed)} seconds`
      if (secondsPassed < 60 * 60) return `${Math.floor(secondsPassed / (60))} minutes`
      if (secondsPassed < 60 * 60 * 24) return `${Math.floor(secondsPassed / (60 * 60))} hours`
      return `${Math.floor(secondsPassed / (60 * 60 * 24))} days`
    }
  },
  methods: {
    toggleIcons () {
      this.showIcons = !this.showIcons
    },
    toggleOverview () {
      this.showOverview = !this.showOverview
    },
    dBmToPercentage (dBm) { // loosly based on https://www.metageek.com/training/resources/wifi-signal-strength-basics.html
      if (dBm > -26 || dBm < -100) return '?' // Unknown value
      if (dBm > -50) dBm = -50
      if (dBm < -87) dBm = -87
      return (100 * (1 - (-50 - dBm) / (-50 - -87))).toFixed(0)
    },
    createdToLocal (unixString) {
      const date = new Date(unixString)
      var options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      }
      return date.toLocaleDateString('default', options)
    }
  },
  created () {
    this.currentTime = Date.now()
    setInterval(() => {
      this.currentTime = Date.now()
    }, 1000)
  }
}
</script>

<style scoped>
  .point-details {
    padding: 0.5rem 1.5rem;
  }
</style>
